import { useCallback, useMemo } from 'react';
import type { ReviewSuggestionsDetailT, SuggestionActionT } from '../../../../common/review-suggestions-side-panel';
import { SUGGESTION_CATEGORY } from '../../../../common/review-suggestions-side-panel';
import type { TrackingValidationResultT } from '../types';
import { categorizeAnnotationValidationDetails, getUniqueTrackingDetailId } from '../utils';
type PropsT = {
  trackingDetails: TrackingValidationResultT[] | null;
  setTrackingDetails: React.Dispatch<React.SetStateAction<TrackingValidationResultT[] | null>>;
};
const useSuggestionsHandlers = ({
  trackingDetails,
  setTrackingDetails
}: PropsT) => {
  // add other types of ml validations data also when needed in future
  const suggestionsData = useMemo(() => {
    if (trackingDetails && trackingDetails.length > 0) {
      return categorizeAnnotationValidationDetails(trackingDetails);
    }
    return [];
  }, [trackingDetails]);
  const suggestionActionHandler = useCallback((item: ReviewSuggestionsDetailT, action: SuggestionActionT) => {
    // The 'action' parameter is intentionally unused since inconsistency tracking does not involve offering suggestions for user to accept or dismiss.
    if (item.category === SUGGESTION_CATEGORY.TRACKING_INCONSISTENCY) {
      setTrackingDetails?.((prevState: TrackingValidationResultT[]) => prevState.filter(trackingDetail => {
        const id = getUniqueTrackingDetailId(trackingDetail);
        return id !== item.id;
      }));
    }
    return Promise.resolve();
  }, [setTrackingDetails]);
  return {
    suggestionsData,
    suggestionActionHandler
  };
};
export default useSuggestionsHandlers;